import React from "react";
import {Grow, Icon} from '@material-ui/core';
import classes from './ShowSkill.module.css';

const ShowSkill = (props) => (
	<div className={classes.FrontEndSkills}>
		<div className={classes.Title}>
			{props.skill.title}
		</div>
		<ul>
			{props.skill.data.map((skill, index) => (
				<Grow in={true} timeout={1000} key={index}>
					<li>
						<div>
							<Icon className={classes.Icon}>check_box_icon</Icon>
							<span>
								{skill}
							</span>
						</div>
					</li>
				</Grow>
			))}
		</ul>
	</div>
)

export default ShowSkill;